import styled from "styled-components"
import { colors } from "../../lib/colors"
import {
  tabletLargeText,
  tabletXlText,
} from "../../media_queries/TabletMediaQueries"
import { settings_props } from "../../pages/settings/SettingsStyles"

export const HeaderWrapper = styled.header<settings_props>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-transform: uppercase;
  position: fixed;
  width: 100%;
  z-index: 2;
  padding: 8px 18px;
  padding-right: 0;
  background: ${({ showSettings }) =>
    showSettings ? "rgba(28,30,36, 0.6)" : "rgba(11, 10, 13, 0.8)"};
  color: ${colors.headerColor};
  box-shadow: inset 0px -1.00948px 0px #292933;
  opacity: ${({ isLoading, tempRemoveComponents }) =>
    isLoading && !tempRemoveComponents ? 1 : 0};
  transition: ${({ tempRemoveComponents }) =>
    tempRemoveComponents ? "opacity 3s" : ""};
  @media (min-width: 768px) {
    padding: 10px 20px;
    padding-right: 0;
    background: rgba(11, 10, 13, 0.8);
  }
  @media (min-width: 1024px) {
    padding: 10px 20px;
    padding-right: 0;
  }
`

export const RightWrapper = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
`
export const Balance = styled.div`
  max-width: 220px;
  margin-right: 45px;
  color: ${colors.headerColor};
  cursor: default;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  line-height: 1;
  p {
    overflow: hidden;
    text-overflow: ellipsis;
    /* margin-right: 20px; */
    font-size: 16px;
  }
  span {
    font-size: 16px;
    text-transform: none;
  }
  @media (min-width: 768px) {
    max-width: 500px;
    margin-right: 60px;
    p {
      ${tabletLargeText}
    }
    span {
      ${tabletLargeText}
    }
  }
  @media (min-width: 1024px) {
    p {
      ${tabletXlText}
    }
    span {
      ${tabletXlText}
    }
  }
`
export const BurgerMenuParent = styled.div`
  padding: 8px 18px 10px;
  height: 15px;
  /* width: 20px; */
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  right: 0;
  height: 100%;
  @media only screen and (min-width: 1024px) {
    padding: 10px 20px 10px 18px;
  }
`

export const BurgerMenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  height: 9px;
  width: 12px;
  position: relative;
  z-index: 100;
  /* padding-right: 18px; */
  padding-left: 15px;
  @media (min-width: 768px) {
    height: 10px;
    width: 14px;
  }
  @media (min-width: 1024px) {
    height: 13px;
    width: 18px;
  }
`
export const MenuLine = styled.p<settings_props>`
  display: inline-block;
  width: 12px;
  height: 1.2px;
  background: ${colors.headerColor};
  transition: all 0.3s ease;
  position: absolute;
  transform-origin: left;
  &:first-of-type {
    top: 0;
    transform: ${({ showSettings }) => (showSettings ? "rotate(47deg)" : "")};
  }
  &:nth-of-type(2n) {
    top: 50%;
    opacity: ${({ showSettings }) => (showSettings ? "0" : "1")};
  }
  &:last-of-type {
    top: 100%;
    transform: ${({ showSettings }) => (showSettings ? "rotate(-48deg)" : "")};
    width: ${({ showSettings }) => (showSettings ? "12px" : "7px")};
  }
  @media (min-width: 768px) {
    width: 14px;
    &:last-of-type {
      transform: ${({ showSettings }) =>
        showSettings ? "rotate(-45deg)" : ""};
      width: ${({ showSettings }) => (showSettings ? "14px" : "9px")};
    }
    &:first-of-type {
      transform: ${({ showSettings }) => (showSettings ? "rotate(45deg)" : "")};
    }
  }
  @media (min-width: 1024px) {
    width: 18px;
    height: 2px;
    &:last-of-type {
      width: ${({ showSettings }) => (showSettings ? "18px" : "12px")};
    }
  }
`

export const ChatWrapper = styled.div`
  cursor: pointer;
`
export const Logo = styled.div`
  font-family: "nasalization";
  color: #abc7db;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 1;
  /* padding: 8px 18px; */

  p {
    font-size: 16px;
    line-height: 1;
    font-family: "nasalization";
    background: ${colors.blueGradient};
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    clip-path: inset(1px 0.5px);
  }
  @media (min-width: 768px) {
    font-size: 18px;
    /* padding: 10px 20px; */
    p {
      font-size: 18px;
    }
  }
  @media (min-width: 1024px) {
    font-size: 22px;
    p {
      font-size: 22px;
    }
  }
`
export const ModeSwitcher = styled.div<{ demo: string }>`
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: ${({ demo }) =>
    demo === "DEMO" ? "#91A63E" : demo === "PROD" ? "#5737D9" : "transparent"};
  background: ${({ demo }) =>
    demo === "DEMO" ? "#2B3213" : demo === "PROD" ? "#191332" : "transparent"};
  border-radius: 3px;
  padding: 4px 6px;
  margin-right: 8px;
  @media (min-width: 768px) {
    font-size: 16px;
  }
`
